import React from "react";

const GridFour = () => {
    return(
        <div className="item-four">
            <div class="insights">
                <h1>Stand out to the right audience</h1>
                <p>Using a collaborative formula of designers, researchers, photographers, videographers, and copywriters, we'll build and extend your brand in digital places</p>
                <a href="#">Learn More</a>
            </div>
        </div>
    )
}

export default GridFour;